import {
  checkProductPending,
  determineProducts,
  determineRegions,
  sortRegions,
} from "../../libs/utils";

import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import CustomExpansionPanel from "../custom-material/expansion-panel/ExpansionPanel";
import CustomExpansionPanelDetails from "../custom-material/expansion-panel/ExpansionPanelDetails";
import Divider from "@material-ui/core/Divider";
import LearnMoreButton from "../common/LearnMoreButton";
import LearnMoreDialogComponent from "../profile-info/LearnMoreDialogComponent";
import PropTypes from "prop-types";
import React from "react";
import { TitleCustomExpansionPanelSummary } from "../custom-material/expansion-panel/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import { isEmpty } from "lodash";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  title: {
    fontSize: 22,
    fontWeight: "normal",
    paddingRight: 0,
  },
  learnMoreButton: {
    marginBottom: 4,
    padding: "4px 10px",
  },
  productGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  productGroupTitle: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    width: "70%",
  },
  productGroupName: {
    fontSize: 16.5,
  },
  productGroupDivider: {
    width: "70%",
    backgroundColor: theme.palette.primary.main,
  },
  productGroupContent: {
    width: "70%",
    marginBottom: 10,
  },
  productPendingLabel: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.38)",
  },
});

class SubscriptionReadOnlyComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      learnMoreDialogOpen: false,
      learnMoreProduct: "",
    };

    this.handleOpenLearnMoreDialog = (productName) => () =>
      this.setState({
        learnMoreDialogOpen: true,
        learnMoreProduct: productName,
      });
    this.handleCloseLearnMoreDialog = () =>
      this.setState({ learnMoreDialogOpen: false, learnMoreProduct: "" });
  }
  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    if (parsed.openModal) {
      this.handleOpenLearnMoreDialog(parsed.openModal)();
    }
  }

  render() {
    const allInternationalCountries = [
      "Brazil",
      "Canada",
      "China",
      "Europe",
      "Japan",
      "Russia",
    ];
    const { classes, contact, subscription } = this.props;
    const { learnMoreDialogOpen, learnMoreProduct } = this.state;
    if (isEmpty(subscription)) return null;
    return (
      <CustomExpansionPanel defaultExpanded expanded>
        <TitleCustomExpansionPanelSummary
          expandIcon={<ArrowRightIcon style={{ fontSize: 50 }} />}
        >
          <Typography className={classes.title}>IPD Solutions</Typography>
        </TitleCustomExpansionPanelSummary>
        <CustomExpansionPanelDetails>
          <React.Fragment>
            {isEmpty(subscription.productGroups) ? (
              <React.Fragment /> // @TODO - empty state
            ) : (
              subscription.productGroups.map((group, productGroupIndex) => (
                <React.Fragment key={productGroupIndex}>
                  <div className={classes.productGroupTitle}>
                    <Typography
                      className={classes.productGroupName}
                      variant="body2"
                    >
                      {(group.name || '').toUpperCase()}
                    </Typography>
                    <LearnMoreButton
                      classes={classes}
                      group={group}
                      handleOpen={this.handleOpenLearnMoreDialog}
                      subscription={subscription}
                    />
                  </div>
                  <Divider className={classes.productGroupDivider} />
                  <div className={classes.productGroupContent}>
                    {isEmpty(group.products) ? (
                      <React.Fragment /> // @TODO - empty state
                    ) : (
                      determineProducts(group.products).map(
                        (product, productIndex) => (
                          <div
                            className={classes.productGroupProduct}
                            key={productIndex}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                marginTop: 8,
                              }}
                            >
                              <span>
                                {product.name}{" "}
                                {checkProductPending(product.regions) ? (
                                  <span className={classes.productPendingLabel}>
                                    {product.name === "Pharma" ||
                                    product.name === "Biologics"
                                      ? "(Pending)"
                                      : product.regions[0].operationType ===
                                        "Add"
                                      ? "(Pending Activation)"
                                      : "(Pending Deactivation)"}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                              <LearnMoreButton
                                classes={classes}
                                group={group}
                                product={product}
                                handleOpen={this.handleOpenLearnMoreDialog}
                                subscription={subscription}
                              />
                            </div>
                            {isEmpty(product.regions) ||
                            product.regions.length === 1 ? (
                              <React.Fragment />
                            ) : (
                              <React.Fragment>
                                {sortRegions(
                                  determineRegions(product.regions)
                                ).map((region, regionIndex) =>
                                  region.name.toLowerCase() ===
                                  "all international" ? (
                                    <React.Fragment>
                                      <div
                                        style={{ marginLeft: 18, marginTop: 6 }}
                                      >
                                        <span>
                                          {allInternationalCountries.join(", ")}{" "}
                                          {(
                                            region.accessStatus || ""
                                          ).toLowerCase() ===
                                          "access pending" ? (
                                            (
                                              region.operationType || ""
                                            ).toLowerCase() === "add" ? (
                                              <span
                                                className={
                                                  classes.productPendingLabel
                                                }
                                              >
                                                (Pending Activation)
                                              </span>
                                            ) : (
                                              <span
                                                className={
                                                  classes.productPendingLabel
                                                }
                                              >
                                                (Pending Deactivation)
                                              </span>
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      <div
                                        style={{ marginLeft: 18, marginTop: 6 }}
                                      >
                                        <span>
                                          {region.name}{" "}
                                          {(
                                            region.accessStatus || ""
                                          ).toLowerCase() ===
                                          "access pending" ? (
                                            (
                                              region.operationType || ""
                                            ).toLowerCase() === "add" ? (
                                              <span
                                                className={
                                                  classes.productPendingLabel
                                                }
                                              >
                                                (Pending Activation)
                                              </span>
                                            ) : (
                                              <span
                                                className={
                                                  classes.productPendingLabel
                                                }
                                              >
                                                (Pending Deactivation)
                                              </span>
                                            )
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </div>
                                    </React.Fragment>
                                  )
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        )
                      )
                    )}
                  </div>
                </React.Fragment>
              ))
            )}
            {learnMoreDialogOpen ? (
              <LearnMoreDialogComponent
                dialogOpen={learnMoreDialogOpen}
                handleCloseDialog={this.handleCloseLearnMoreDialog}
                majorCategory={subscription.majorCategory}
                minorCategory={subscription.minorCategory}
                subClass={subscription.subClass}
                productName={learnMoreProduct}
                contact={contact}
              />
            ) : null}
          </React.Fragment>
        </CustomExpansionPanelDetails>
      </CustomExpansionPanel>
    );
  }
}

SubscriptionReadOnlyComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  contact: PropTypes.object,
  subscription: PropTypes.object,
};

export default withRouter(withStyles(styles)(SubscriptionReadOnlyComponent));
